import React from 'react';
import './FilterStyles.css';

const IMDFilter = ({ filter, onUpdate, onRemove }) => {
  const { minDecile = 1, maxDecile = 10 } = filter.values;

  const handleMinChange = (e) => {
    const newMin = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        minDecile: newMin,
        maxDecile: Math.max(newMin, maxDecile)
      }
    });
  };

  const handleMaxChange = (e) => {
    const newMax = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        minDecile: Math.min(minDecile, newMax),
        maxDecile: newMax
      }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>IMD Decile</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        <div className="range-display">
          <strong>Range:</strong> {minDecile} to {maxDecile}
        </div>

        <div className="dual-range-control">
          <div className="dual-range-wrapper">
            <input
              type="range"
              min="1"
              max="10"
              value={minDecile}
              onChange={handleMinChange}
              className="range-slider range-slider-min"
            />
            <input
              type="range"
              min="1"
              max="10"
              value={maxDecile}
              onChange={handleMaxChange}
              className="range-slider range-slider-max"
            />
          </div>
          <div className="dual-range-labels">
            <span className="range-label">{minDecile}</span>
            <span className="range-label">{maxDecile}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IMDFilter;
